
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Fade, IconButton, Stack } from '@mui/material';
import { useEffect, useState } from 'react';

import { APPBAR_HEIGHT } from '@/layouts/AppLayout/AppLayout.styles';
import { useNotificationStore } from '@/store/notificationStore';

import type { Notification } from '@/store/notificationStore';

const AUTO_HIDE_MS = 30_000;
const FADE_DURATION_MS = 400;

interface NotificationItemProps {
  notification: Notification;
  onRemove: (id: string) => void;
}

const NotificationItem = ({ notification, onRemove }: NotificationItemProps): JSX.Element => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), AUTO_HIDE_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Fade in={visible} timeout={FADE_DURATION_MS} onExited={() => onRemove(notification.id)}>
      <Alert
        severity={notification.severity}
        sx={{ minWidth: 280, maxWidth: 420, boxShadow: 3 }}
        action={
          <IconButton
            size="small"
            aria-label="chiudi notifica"
            color="inherit"
            onClick={() => setVisible(false)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {notification.message}
      </Alert>
    </Fade>
  );
};

export const AlertBar = (): JSX.Element => {
  const { notifications, removeNotification } = useNotificationStore();

  return (
    <Stack
      spacing={1}
      role="region"
      aria-label="Notifiche di sistema"
      sx={{ position: 'fixed', top: APPBAR_HEIGHT + 8, right: 16, zIndex: 2000 }}
    >
      {notifications.map((n) => (
        <NotificationItem key={n.id} notification={n} onRemove={removeNotification} />
      ))}
    </Stack>
  );
};
